import _ from 'underscore';
import { scopeStore } from '@bingads-webui-campaign/global-context-store';

/* eslint-disable no-underscore-dangle */
export function initPDL(serverContext) { // adobe tracking script will use window._PDL to provide info
  window._PDL = window._PDL || {};
  window._PDL.market = _.result(serverContext.Omniture, 'Market');
  window._PDL.pageName = _.result(serverContext.Omniture, 'PageNamePDL');
  window._PDL.navLevel1 = _.result(serverContext.Omniture, 'NavLevel1');
  window._PDL.navLevel2 = _.result(serverContext.Omniture, 'NavLevel2');
  window._PDL.accountNumber = _.result(serverContext.Omniture, 'CurrentAccountNumber');
  window._PDL.customerID = _.result(serverContext.Omniture, 'CustomerID');
  window._PDL.userID = _.result(serverContext.Omniture, 'UserID');
  window._PDL.serverName = _.result(serverContext.Omniture, 'ServerName');
  const permissions = _.chain(serverContext.Permissions)
    .pairs()
    .map(item => (item[1] ? item[0] : null))
    .compact()
    .value();

  const dynamicPermissions = _.chain(serverContext.DynamicPermissions)
    .pairs()
    .map(item => (item[1] ? item[0] : null))
    .compact()
    .value();

  window._PDL.permissions = [].concat(permissions).concat(dynamicPermissions).join(',');

  scopeStore.subscribe(() => {
    const { campaignId, adGroupId } = scopeStore.state.scope.values;
    window._PDL.campaignID = campaignId;
    window._PDL.adGroupID = adGroupId;
  });
}
